import React from 'react';
import Select from '../../../components/ui/Select';

const SpecializationSelect = ({ value, onChange, error, required = false }) => {
  const specializationOptions = [
    { value: 'civil', label: 'حقوق مدنی', description: 'قراردادها، املاک، خانواده' },
    { value: 'criminal', label: 'حقوق جزا', description: 'دفاع کیفری، جرائم' },
    { value: 'commercial', label: 'حقوق تجاری', description: 'شرکت‌ها، قراردادهای تجاری' },
    { value: 'labor', label: 'حقوق کار', description: 'روابط کارگر و کارفرما' },
    { value: 'administrative', label: 'حقوق اداری', description: 'دیوان عدالت اداری' },
    { value: 'tax', label: 'حقوق مالیاتی', description: 'مسائل مالیاتی و گمرکی' },
    { value: 'intellectual', label: 'مالکیت فکری', description: 'ثبت اختراع، علائم تجاری' },
    { value: 'international', label: 'حقوق بین‌الملل', description: 'قراردادهای بین‌المللی' },
    { value: 'environmental', label: 'حقوق محیط زیست', description: 'قوانین زیست محیطی' },
    { value: 'banking', label: 'حقوق بانکی', description: 'قراردادهای بانکی و مالی' },
    { value: 'insurance', label: 'حقوق بیمه', description: 'قراردادهای بیمه' },
    { value: 'real_estate', label: 'حقوق املاک', description: 'خرید و فروش املاک' },
    { value: 'family', label: 'حقوق خانواده', description: 'طلاق، نفقه، حضانت' },
    { value: 'inheritance', label: 'حقوق ارث', description: 'تقسیم ارث، وصیت‌نامه' },
    { value: 'medical', label: 'حقوق پزشکی', description: 'اخطاء پزشکی، بیمه درمان' }
  ];

  return (
    <Select
      label="تخصص حقوقی"
      description="حوزه تخصصی اصلی خود را انتخاب کنید"
      placeholder="انتخاب تخصص..."
      options={specializationOptions}
      value={value}
      onChange={onChange}
      error={error}
      required={required}
      searchable
      clearable
    />
  );
};

export default SpecializationSelect;